import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLazyQuery } from "@apollo/client";
import {
  setSiteUsers,
  setSiteUsersError,
  setSiteUsersLoading,
} from "../actions";
import { GET_SITE_USERS_FOR_SITE } from "../graphql/queries";

// eslint-disable-next-line import/prefer-default-export
export const useGetSiteUsers = ({
  ascending,
  filter,
  searchTerm,
  siteId,
  sortfield,
}) => {
  const [getSiteUsersForSite, { data, loading, error }] = useLazyQuery(
    GET_SITE_USERS_FOR_SITE,
    {
      variables: {
        ascending,
        filter,
        searchTerm,
        siteId,
        sortfield,
      },
    }
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (
      data &&
      data.siteUsers &&
      Array.isArray(data.siteUsers.listSiteUsersForSite)
    ) {
      dispatch(
        setSiteUsers({
          items: data.siteUsers.listSiteUsersForSite,
        })
      );
    }
  }, [data]);

  useEffect(() => {
    dispatch(
      setSiteUsersLoading({
        loading,
      })
    );
  }, [loading]);

  useEffect(() => {
    if (error) {
      dispatch(
        setSiteUsersError({
          error,
        })
      );
    }
  }, [error]);

  return { execute: getSiteUsersForSite, data, loading, error };
};
